export const newsletter = (() => {
    const orgInput = document.getElementById('newsletter-orgnr');
    const Kursutskick = document.getElementById('Kursutskick');
    const Arbetsgivarbrevet = document.getElementById('Arbetsgivarbrevet');
    const Konjukturbrevet = document.getElementById('Konjukturbrevet');
    const Extract = document.getElementById('Extract');
    const PolicyBrief = document.getElementById('PolicyBrief');
    const labelButton = document.getElementById('NewsletterLabelButton');
    const dropdown = document.getElementById('NewsletterDropdown');
    const orgParent = document.getElementById("newsletter-orgnrWrap");

    if (!orgInput) return;

    labelButton.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        dropdown.classList.toggle("interact-dropdown--open");
    })

    Kursutskick.addEventListener("change", function (e) {
        checkOrgInput();
    })

    Arbetsgivarbrevet.addEventListener("change", function (e) {
        checkOrgInput();
    })

    Konjukturbrevet.addEventListener("change", function (e) {
        setLabel();
    })

    Extract.addEventListener("change", function (e) {
        setLabel();
    })

    function checkOrgInput() {
        if (Kursutskick.checked || Arbetsgivarbrevet.checked) {
            orgParent.classList.remove("interact-mandatory-hidden");
            orgParent.setAttribute("aria-hidden", "false");
            orgInput.setAttribute("required", "required");
        } else {
            orgParent.classList.add("interact-mandatory-hidden");
            orgParent.setAttribute("aria-hidden", "true");
            orgInput.removeAttribute("required");
        }
    };

    function setLabel() {
        const label = document.querySelector('.interact-dropdown-label');
        const checkedFields = [];

        if (Extract.checked) {
            checkedFields.push(document.querySelector('.interact--extract').innerText);
        }

        if (Konjukturbrevet.checked) {
            checkedFields.push(document.querySelector('.interact--economy').innerText);
        }

        if (Arbetsgivarbrevet.checked) {
            checkedFields.push(document.querySelector('.interact--employerLetter').innerText);
        }

        if (Kursutskick.checked) {
            checkedFields.push(document.querySelector('.interact--courseMaterial').innerText);
        }

        if (PolicyBrief.checked) {
            checkedFields.push(document.querySelector('.interact--policy').innerText);
        }

        if (label) {
            label.innerHTML = checkedFields.length > 1 ? `${checkedFields.length} valda` : checkedFields[0] || 'Välj nyhetsbrev';
        }
    };

    document.addEventListener("click", (e) => {
        if (dropdown.classList.contains("interact-dropdown--open") && !e.target.closest(".interact-dropdown")) {
            dropdown.classList.toggle("interact-dropdown--open");
        }
    });
})();
